export const urlFind = {
  any: new RegExp('((http|ftp|https):\\/\\/)?[\\w\\-_]+(\\.[\\w\\-_]+)+([\\w\\-\\.,@?^=%&:/~\\+#]*[\\w\\-\\@?^=%&/~\\+#])?'),
  httpsOnly: /(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?/
}
export const string = {
  replaceAllSpace: (str, value) => str.replace(/ /g, value),
  replacePunctuationAndSpaces: (str, replaceWith = '_') => str.replace(/[.",/#!?$%^&*;:{}=\-_`~()]/g, "").replace(/\s/g, replaceWith),
}